<template>
  <footer class="footer" ref="footer">
    <div class="footer__top">
      <div class="footer-tagline__text fs-200" v-observe>
        <span
          class="footer-tagline__char"
          :style="{ '--index': i }"
          v-for="(char, i) in [...`©FP${globals.shortYear}`]"
        >
          {{ char }}
        </span>
      </div>
      <AppSocialLinks class="footer__links fs-16" />
      <ClientOnly v-if="!$mq.isMobileOrTablet">
        <AppMedia
          class="footer__reel"
          :video="'https://pub-dfd09a1f367a4139805489ff686a8b0d.r2.dev/Projects/Reel/REEL_THUMB_WEB.mp4'"
          :video-webm="'https://pub-dfd09a1f367a4139805489ff686a8b0d.r2.dev/Projects/Reel/REEL_THUMB_WEB.webm'"
          :autoplay="true"
        >
        </AppMedia>
      </ClientOnly>
    </div>

    <div class="footer__bottom fs-12">
      <span class="footer__legal">
        © {{ globals.year }} ALL RIGHTS RESERVED</span
      >
      <a :href="`mailto:${globals.email}`">
        <AppLink class="tt-u"> {{ globals.email }}</AppLink>
      </a>
      <ClientOnly>
        <span class="footer__vat" v-show="!$mq.isMobileOrTablet">
          VAT N. {{ globals.vat }}</span
        >
      </ClientOnly>
    </div>
  </footer>
</template>

<script setup>
const footer = ref(false);
const globals = useGlobal();
const { $mq } = useNuxtApp();

const props = defineProps({
  page: { type: String, default: 'index' },
});
</script>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid var(--c-border);
  bottom: 0;
  clip-path: inset(0 0 -5% 0);
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
  left: 0;
  margin-top: 50rem;
  margin: 0 auto;
  overflow: hidden;
  padding-top: var(--offset);
  right: 0;
  width: var(--width);
  will-change: transform;
  z-index: layer(overlay);
  padding-bottom: var(--offset);
}

.footer__top {
  display: flex;
  gap: var(--gutter);
  width: 100%;
  margin-bottom: fluidMap($spacing, 300);
}

.footer__reel {
  aspect-ratio: 16/9;
  background: #eee;
  justify-self: flex-end;
  margin-left: auto;
  width: var(--col-1);
}

.footer-tagline__text {
  display: flex;
  flex-shrink: 0;
  height: 1.1cap;
  line-height: 0.9;
  // margin-left: -0.03em;
  user-select: none;
  width: var(--col-3);
  clip-path: inset(0 0 -5% 0);

  @include mqDown(desktop) {
    font-size: 4rem;
  }
}

.footer-tagline__char {
  display: inline-flex;
  transform: translateY(110%);

  .is-inview & {
    transform: translateY(0);
    transition: transform 1s ease(outExpo) calc(var(--index) * 0.1s);
  }
}

.footer__links {
  display: flex;
  flex-direction: column;
}

.footer__links li:not(:last-child) {
  padding-bottom: 0.1em;
}

.footer__bottom {
  display: flex;
  gap: var(--gutter);
  width: 100%;

  @include mqDown(desktop) {
    font-size: 10px;
    justify-content: space-between;
  }
}

.footer__legal {
  @include mq(desktop) {
    width: var(--col-3);
  }
}

.footer__vat {
  justify-self: flex-end;
  margin-left: auto;
}
</style>
